import React, { useState } from 'react';
import { Modal, Text } from './DeleteAllDataModal.styles';
import { TextInput } from 'Settings/TextInput';
import { ApToggleSwitch } from '@alixpartners/ui-components';

const DELETE_PHRASE = 'delete data';

const INITIAL_STATE = {
	enableDeleteBtn: false,
	value: '',
};

const DeleteAllDataModal = props => {
	const {
		onConfirm,
		onCancel,
		inProgress,
		onCheckDeleteHistoryHandler,
		isDeleteHistory,
	} = props;
	const [state, setState] = useState(INITIAL_STATE);

	const onInputChange = e => {
		setState({
			value: e.target.value,
			enableDeleteBtn:
				e.target.value && e.target.value.toLowerCase() === DELETE_PHRASE,
		});
	};

	return (
		<Modal
			title={
				inProgress
					? 'Delete in-progress...'
					: 'Are you sure you want to delete all data?'
			}
			cancelLabel={!inProgress ? 'Cancel' : null}
			submitLabel="Ok"
			onClose={onCancel}
			onSubmit={state.enableDeleteBtn && !inProgress ? onConfirm : null}
		>
			{inProgress ? (
				'Please wait.'
			) : (
				<Text>
					<p>
						You are about to delete Supplier Diversity data from the
						application.
					</p>
					<ApToggleSwitch
						checked={isDeleteHistory}
						onChange={onCheckDeleteHistoryHandler}
					>
						Delete history
					</ApToggleSwitch>
					<br />
					<TextInput
						value={state.value}
						name="deleteCheck"
						label={`Type [${DELETE_PHRASE.toUpperCase()}] in the box below and click OK.`}
						onChange={onInputChange}
					/>
				</Text>
			)}
		</Modal>
	);
};

export default DeleteAllDataModal;
